'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _OMTitle = require('../../components/OMComponents/OMTitle/OMTitle');var _OMTitle2 = _interopRequireDefault(_OMTitle);

var _PrivacyPolicyPage = require('../PrivacyPolicyPage/PrivacyPolicyPage.scss');var styles = _interopRequireWildcard(_PrivacyPolicyPage);

var _constants = require('../../constants');
var _multiLanguageHeadTags = require('../../helpers/multiLanguageHeadTags');var _multiLanguageHeadTags2 = _interopRequireDefault(_multiLanguageHeadTags);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Styles
// Helpers
var AboutUsPage = function (_Component) {_inherits(AboutUsPage, _Component);function AboutUsPage() {var _temp, _this, _ret;_classCallCheck(this, AboutUsPage);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.numberOfParenthesis = 7, _this.
    mapReference = new Array(_this.numberOfParenthesis - 1).fill(1), _this.
    parenthesis = [], _this.

    state = {
      texts: [] }, _this.












    setParenthesis = function () {var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
      var texts = _this.parenthesis.map(function (paren, idx) {return props.translate('parenthesis.' + (idx + 1));});
      _this.setState({ texts: texts });
    }, _this.

    addParenthesisRef = function (ref) {
      _this.parenthesis.push(ref);
    }, _this.

    renderDiv = function () {var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;return _react2.default.createElement('div', {
        ref: _this.addParenthesisRef,
        dangerouslySetInnerHTML: { __html: _this.state.texts[index] } });}, _temp), _possibleConstructorReturn(_this, _ret);} // eslint-disable-line react/sort-comp
  AboutUsPage.prototype.componentDidMount = function componentDidMount() {this.setParenthesis();};AboutUsPage.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {if (newProps.locale && newProps.locale !== this.props.locale) {this.setParenthesis(newProps);}};AboutUsPage.prototype.

  render = function render() {var _cx,_this2 = this;var _props =
    this.props,route = _props.route,location = _props.location,locale = _props.locale,isNative = _props.isNative;
    var multiLanguage = (0, _multiLanguageHeadTags2.default)(route, locale);

    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.main_block, 'pageHeight', (_cx = {}, _cx[styles.native] = isNative, _cx)) },
        _react2.default.createElement('div', { className: styles.content },
          _react2.default.createElement(_reactHelmet2.default, {
            titleTemplate: this.props.staticTranslate('title', 'titleTemplate')(),
            title: this.props.staticTranslate('title', 'about')(),
            meta: [
            { property: 'og:url', content: '' + _constants.shareUrl + route },
            { property: 'og:title', content: this.props.title + ' | \u202BOnMap' },
            { property: 'og:description', content: this.props.staticTranslate('helmet', 'aboutDescription') },
            { name: 'description', content: this.props.staticTranslate('helmet', 'aboutDescription') }],

            link: [].concat(
            multiLanguage, [
            { rel: 'canonical', href: '' + _constants.shareUrl + route }]) }),


          _react2.default.createElement('div', { className: styles.aboutWrap },

            !this.props.isNative &&
            _react2.default.createElement(_OMTitle2.default, { className: 'pageTitle', title: this.props.title }),


            _react2.default.createElement('div', null, this.props.translate('1.1')),
            this.renderDiv(),
            _react2.default.createElement('br', null),
            _react2.default.createElement('ul', { className: styles.points },

              this.mapReference.map(function (item, index) {return (
                  _react2.default.createElement('li', { key: index }, _this2.renderDiv(index + 1)));}) // eslint-disable-line react/no-array-index-key
            )))));





  };return AboutUsPage;}(_react.Component);


AboutUsPage.propTypes = {
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  staticTranslate: _propTypes2.default.func,
  title: _propTypes2.default.func,
  route: _propTypes2.default.any,
  isMobile: _propTypes2.default.bool,
  location: _propTypes2.default.object,
  isNative: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(_ref) {var lang = _ref.lang,native = _ref.native;return {
    title: (0, _reduxPagan.getLang)(lang, 'static', 'header', 'aboutUs'),
    staticTranslate: (0, _reduxPagan.getLang)(lang, 'static'),
    isNative: native.isNative,
    translate: (0, _reduxPagan.getLang)(lang, 'about') };};exports.default =


(0, _reactRedux.connect)(mapStateToProps)(
AboutUsPage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/AboutUsPage/AboutUsPage.js
// module id = 3082
// module chunks = 0